// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1Fksx","right":"Footer_right__2x010","buttons":"Footer_buttons__3W8DB"};